import { useSetRecoilState } from 'recoil';
import { useMutation } from 'services/api/hooks';
import { updateCandidate } from 'services/candidate/api';
import {
  candidateRejectionModalAtom,
  candidateShortlistingModalAtom
} from 'services/candidate/atoms';
import { CandidateStatus } from 'services/candidate/types';
import {
  useInterviewStages,
  useRejectedReasons
} from 'services/integration/hooks';

export const useCandidateDecision = ({
  atsJobId
}: {
  atsJobId: string | undefined | null;
}) => {
  const { mutate: updateCandidateApi } = useMutation(updateCandidate, {
    disableSuccessToast: true
  });

  useRejectedReasons({
    atsJobId
  });

  useInterviewStages({
    atsJobId
  });

  const setRejectionModalState = useSetRecoilState(candidateRejectionModalAtom);
  const setShortlistingState = useSetRecoilState(
    candidateShortlistingModalAtom
  );

  const shortList = ({
    candidateIds,
    candidateBatchId
  }: {
    candidateIds: string[];
    candidateBatchId: string;
  }) => {
    setShortlistingState({
      candidateIds,
      candidateBatchId,
      isOpen: true
    });
  };

  const reject = ({
    candidateIds,
    candidateBatchId
  }: {
    candidateIds: string[];
    candidateBatchId: string;
  }) => {
    setRejectionModalState({
      candidateIds,
      candidateBatchId,
      isOpen: true
    });
  };

  const closeModals = () => {
    setRejectionModalState({
      candidateIds: [],
      candidateBatchId: undefined,
      isOpen: false
    });
    setShortlistingState({
      candidateIds: [],
      candidateBatchId: undefined,
      isOpen: false
    });
  };

  const putInReview = async ({ candidateIds }: { candidateIds: string[] }) => {
    await Promise.all(
      candidateIds.map((candidateId) =>
        updateCandidateApi({
          id: candidateId,
          status: CandidateStatus.REVIEW
        })
      )
    );
  };

  return {
    reject,
    shortList,
    putInReview,
    closeModals
  };
};
